import React, { useState } from 'react';
import axios from 'axios';
import QrScanner from 'react-qr-scanner';
import Breadcrumb from './Breadcrumb';
import { useLanguage } from '../../store/language-context';
import { useTranslation } from 'react-i18next';

const CheckCertificate = () => {
  const { URL } = useLanguage();
  const { t } = useTranslation();
  const [serialNumber, setSerialNumber] = useState('');
  const [certificate, setCertificate] = useState(null);
  const [error, setError] = useState('');
  const [showScanner, setShowScanner] = useState(false);
  const [inputMethod, setInputMethod] = useState(null); // Start with null, no method selected

  const fetchCertificate = async (code) => {
    try {
      // Clear previous results and errors
      setError('');
      setCertificate(null);

      // Make the API request
      const response = await axios.get(
        `${URL}/certificate_verification?serial_number=${code}`
      );

      // Check the response status and data
      if (response.data.status === 200 && response.data.data.data.length > 0) {
        setCertificate(response.data.data.data[0]);
      } else {
        // Display the error message from the server response
        setError(response.data.message || t('verification.no-result'));
      }
    } catch (err) {
      // Handle network or unexpected errors
      setError(err.response?.data?.message || t('custom.errr'));
    }
  };

  const handleScan = (data) => {
    if (data) {
      setShowScanner(false);
      setSerialNumber(data.text);
      fetchCertificate(data.text);
    }
  };

  const handleError = (err) => {
    console.error(err);
    setError(t('verification.err'));
  };

  const handleInputChange = (event) => {
    setSerialNumber(event.target.value);
  };

  const toggleScanner = () => {
    setShowScanner(!showScanner);
    if (!showScanner) {
      setError('');
    }
  };

  return (
    <>
      <Breadcrumb pages={[t('routes.certificate-verification')]} />
      <div className="container">
        <div className="two-check row mt-4 mb-4 justify-content-between align-items-start">


          <div className='check-certificate col-lg-5' >
            <p className='text-center font-semibold'>{t('verification.by')} </p>

            {/* Radio buttons to toggle input method */}
            <div style={{ display: 'flex', justifyContent: 'space-around', marginBottom: '20px' }}>

              <label>

                <input
                  type="radio"
                  name="inputMethod"
                  value="manual"
                  checked={inputMethod === 'manual'}
                  onChange={() => setInputMethod('manual')}
                />
                {t('verification.code')}<span>{t('verification.serial')} </span>
              </label>
              <label>
                <input
                  type="radio"
                  name="inputMethod"
                  value="qr"
                  checked={inputMethod === 'qr'}
                  onChange={() => setInputMethod('qr')}
                />
                Qr Code Scanner
              </label>
            </div>

            {/* Show input based on selected method */}
            {inputMethod === 'manual' && (
              <div className='manual-form'>
                <h6>{t('verification.enter-code')}</h6>
                <input
                  type="text"
                  placeholder={t('verification.code-holder')}
                  value={serialNumber}
                  onChange={handleInputChange}
                  style={{
                    width: '100%',
                    padding: '10px',
                    marginBottom: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                  }}
                />
                <span>{t('verification.certificate-code')}</span>
                <button
                  onClick={() => fetchCertificate(serialNumber)}
                  style={{
                    minWidth: '120px',
                    padding: '10px',
                    backgroundColor: '#6A2F38',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    margin: '10px auto',
                  }}
                >
                  {t('custom.ok')}
                </button>
              </div>
            )}

            {inputMethod === 'qr' && (
              <div>
                <button
                  onClick={toggleScanner}
                  style={{
                    minWidth: '120px',
                    padding: '10px',
                    backgroundColor: '#6A2F38',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    margin: '10px auto',
                  }}
                >
                  {showScanner ? t('verification.close') : t('verification.see')}
                </button>
                {showScanner && (
                  <div style={{ marginBottom: '20px' }}>
                    <QrScanner
                      delay={300}
                      onError={handleError}
                      onScan={handleScan}
                      style={{ width: '100%' }}
                    />
                  </div>
                )}
              </div>
            )}

            {/* Display error message */}
            {error && (
              <p
                style={{
                  color: 'red',
                  marginTop: '10px',
                  fontSize: '16px',
                  fontWeight: 'bold',
                }}
              >
                {error}
              </p>
            )}


          </div>
          <div className="check-result col-lg-6 row justify-content-center">

            <div className="apear-certificate col-lg-8 col-md-10">
              {/* Display certificate details */}
              {certificate && (
                <div
                  style={{
                    marginTop: '20px',
                    padding: '15px',


                  }}
                >
                  <h3>{t('verfication.details')}</h3>
                  <p>
                    <strong>{t('contact.name')}:</strong> {certificate.user_name_ar || t('verification.not-available')}
                  </p>
                  <p>
                    <strong>{t('contact.email')}:</strong> {certificate?.email || t('verification.not-available')}
                  </p>
                  <p>
                    <strong>{t('verifixation.hours')}:</strong> {certificate?.count_hours || t('verification.not-available')}
                  </p>
                  <p>
                    <a href={certificate?.link} style={{ color: '#6A2F38' }}>{t('verification.download-certificate')}</a>
                  </p>
                </div>
              )}
            </div>

          </div>
        </div>
      </div>

    </>
  );
};

export default CheckCertificate;
